import { render, staticRenderFns } from "./SignComp.vue?vue&type=template&id=a3f39f8e"
import script from "./SignComp.vue?vue&type=script&lang=js"
export * from "./SignComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports